import { hr as reacthr } from '@ews/react-translations';

const hr = {
...reacthr
}
export default hr
